export enum LOGIN_TYPES {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
  OAUTH = 'OAUTH',
}
